import React, { Suspense, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { BakeShadows, useProgress } from '@react-three/drei';
import { Lights } from './Lights';
import { Environment } from './Environment';
import { useGlobal } from '../../../logic/main';
import { boardConfig } from '../../../config/boardConfig';
import { Debugger, DebuggerView } from './Debugger';
import { cloneDeep } from 'lodash';
import { CustomColors } from '../../../styles/variables';
import { sRGBEncoding } from 'three';
import { DeviceDetector } from '../../../utils/helper/browserDetection';

export const SzeneWrapper: React.FC = ({ children }) => {
    const [{ camera }, { setLoadingProgress }] = useGlobal(
        state => ({ camera: state.cameraInstance, cameraConfig: state.currentCameraConfig }),
        action => ({ setLoadingProgress: action.setLoadingProgress })
    );

    const { progress } = useProgress();

    useEffect(() => {
        if (progress > 0) {
            setLoadingProgress(progress);
        }
    }, [progress, camera]);

    return (
        <>
            <Canvas
                shadows={true}
                camera={{ ...cloneDeep(boardConfig.cameraConfigs['scanner']), fov: DeviceDetector.isMobile ? 100 : 75 }}
                style={{ background: CustomColors.tertiary }}
                gl={{
                    powerPreference: 'default',
                    alpha: false,
                    antialias: false,
                    outputEncoding: sRGBEncoding,
                    physicallyCorrectLights: false,
                    stencil: false,
                    depth: true
                }}
            >
                <color attach="background" args={[CustomColors.tertiary]} />
                <Suspense fallback={null}>
                    <Lights />
                    <Environment>{children}</Environment>
                    <BakeShadows />
                </Suspense>
                <Debugger isEnabled={boardConfig.debug} />
            </Canvas>
            <DebuggerView isEnabled={boardConfig.debug} />
        </>
    );
};
